export default {
	app: {
		lang: '语言',
		layoutSetting: '布局设置',
		logoutButton: '退出登录'
	},
	request: {
		loginExpired: '登录状态已过期，您可以继续留在该页面，或者重新登录',
		systemHint: '系统提示',
		logInAgain: '重新登录',
		cancel: '取消',
		invalidSession: '无效的会话，或者会话已过期，请重新登录。',
		networkError: '后端接口连接异常',
		systemTimeout: '系统接口请求超时',
		systemInterfaceError: '系统接口{code}异常',
		downloadingData: '正在下载数据，请稍候',
		downloadingFileError: '下载文件出现错误，请联系管理员！'
	},
	common: {
		searchButton: '查询',
		resetButton: '重置',
		addButton: '新增',
		editButton: '编辑',
		copyButton:'复制',
		removeButton: '删除',
		batchRemoveButton: '批量删除',
		detailButton: '详情',
		handler: '操作',
		pleaseInput: '请输入{label}',
		pleaseSelect: '请选择{label}',
		pleaseUpload: '请上传{label}',
		startTime: '开始时间',
		endTime: '结束时间',
		productAccess:'产品类型',
		firmwareManagement:'整机固件管理',
		taskManagement:'任务管理',
		firmwareName:'整机固件名称',
		modelName:'型号名称',
		functionName:'功能名称',
		productType:'产品类型',
		templateName:'模板名称',
		documentName:'文档名称',
		moduleName:'模组名称',
		supplierName:'供应商名称',
		taskName:'任务名称',
		saveButton:'保存',
		draftButton:'暂存',
		backInsert:'行值后插',
		beforeInsert:'行值前插',
		startTheExperience:'开始体验',
		superExperience:'叠加体验',
		moveUp:'上移',
		moveDown:'下移',
		test:'测试'
	},
	test: {
		id: 'ID',
		name: '名称',
		grand: '品牌',
		handler: '操作',
		enterName: '请输入名称',
		enterId: '请输入ID'
	},
	deviceManagement: {
		productList: {
			productName: '产品名称',
			productType: '产品分类',
			createTime: '创建时间',
			connectType: '接入方式',
			netType: '网络类型',
			protocolType: '通信协议',
			identifyType: '认证方式',
			transparent: '是否透传',
			createBy: '创建者',
			protocolFile: '协议文件',
			protocolFileDesc: '协议文件说明',
			productDesc: '协议描述',
			deviceTotal: '设备总数'
		},
		equipmentBatch: {
			batchName: '批次名称',
			attributedProducts: '归属产品',
			deviceId: '设备ID',
			batchCount: '批次设备数量',
			createTime: '创建时间',
			createBy: '创建者',
			deviceBeginId: '设备起始ID',
			deviceDetail: '设备详情'
		},
		equipmentList: {
			deviceId: '设备ID',
			netStatus: '网络状态',
			deviceStatus: '设备状态',
			lastLoginTime: '最近登录时间',
			lastLogoutTime: '最近离线时间',
			deviceRuningTotalTime: '设备运行总时长',
			createTime: '创建时间'
		}
	},
	remoteUpgrade: {
		firmwarePackage: {
			firmwareName: '固件版本名称',
			usingVersion: '当前版本号',
			attributedProducts: '归属产品',
			createBy: '创建者',
			createTime: '创建时间',
			updateBy: '更新者',
			updateTime: '更新时间',
			firmwarePackageVersion: '版本号',
			updateLogs: '更新日志',
			firmwarePackageUpgrade: '固件上传',
			enable: '启用',
			disable: '停用'
		}
	}
}
